import type { App } from 'vue';
import auth from './auth';
import { fileDropDirective } from 'vue-devui-lal/upload';

// 注册到全局的指令
const GLOBAL_DIRECTIVES = {
  'auth': auth,
  'file-drop': fileDropDirective
} as { [name: string]: object; };

export default {
  install(app: App) {
    Object.keys(GLOBAL_DIRECTIVES).forEach((name: string) => {
      app.directive(name, GLOBAL_DIRECTIVES[name]);
    });
  }
};
